export default __webpack_public_path__ + "5fbdae2c58f39e11cd7744e668f67478.png";